export default "__VITE_ASSET__DuzOzWz$__"